import react, { useRef, useState, useEffect } from 'react';
import { useSnapshot } from 'valtio';
import io from 'socket.io-client';
import { useNavigate } from 'react-router-dom';
import { state } from '../store/global';

import NotificationModal from '../components/modal/NotificationModal';
import ProfileModal from '../components/modal/ProfileModal';
import NewItem from '../components/common/NewsItem';

import BellIcon from '../assets/images/bell.svg';

import UserIcon from '../components/svg/UserIcon';
import LockIcon from '../components/svg/LockIcon';
import SignOutIcon from '../components/svg/SignOutIcon';

const profileMenu = [
  {
    title: 'Mi perfil',
    icon: (size, color) => <UserIcon size={size} color={color} />,
  },
  {
    title: 'Seguridad',
    icon: (size, color) => <LockIcon size={size} color={color} />,
  },
  {
    title: 'Cerrar sesión',
    icon: (size, color) => <SignOutIcon size={size} color={color} />,
  },
];

export default function Headerbar() {
  const snap = useSnapshot(state);
  const navigate = useNavigate();

  const notificationContainerRef = useRef(null);
  const profileContainerRef = useRef(null);
  const [isOpenAlarm, setIsOpenAlarm] = useState(false);
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const [isDetailNotification, setIsDetailNotification] = useState(false);
  const [isDetailProfile, setIsDetailProfile] = useState('');

  const socketRef = useRef(null);
  const [newNotifications, setNewNotifications] = useState([]);
  const [oldNotifications, setOldNotifications] = useState([]);
  const [isConnected, setIsConnected] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(false);
  const token = localStorage.getItem('token');

  useEffect(() => {
    // Initialize Socket.IO connection
    socketRef.current = io(import.meta.env.VITE_SERVER_URL, {
      transports: ['websocket', 'polling'],
      timeout: 10000,
      auth: {
        token: token,
        userId: snap.user.id,
      },
    });

    const socket = socketRef.current;

    // Connection event handlers
    socket.on('connect', () => {
      setIsConnected(true);
      setConnectionStatus('Connected');
      console.log('Connected to server');

      // Optional: Authenticate with user ID
      const userId = snap.user.id; // Get this from your auth system
      socket.emit('notifications', { userId });
    });

    socket.on('disconnect', () => {
      setIsConnected(false);
      setConnectionStatus('Disconnected');
      console.log('Disconnected from server');
    });

    socket.on('connect_error', (error) => {
      setConnectionStatus('Connection Error');
      console.error('Connection error:', error);
    });

    // Notification event handlers
    socket.on('notification', (notification) => {
      console.log('Notification received:', notification);
      addNotification(notification);
      showBrowserNotification('Notification', notification.description);
    });

    socket.on('notifications', (data) => {
      // console.log('notification data from server: ', data);
      showBrowserNotification('Notification', 'Received notification data from server');

      const oldData = data.filter((item) => item.viewed == true);
      const newData = data.filter((item) => item.viewed == false);
      setNewNotifications([...newData]);
      setOldNotifications([...oldData]);
    });

    requestNotificationPermission();

    // Cleanup on component unmount
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
      }
    };
  }, []);
  const addNotification = (notification) => {
    setNewNotifications((prev) => [notification, ...prev.slice(0, 49)]); // Keep last 50
  };

  const showBrowserNotification = (title, message) => {
    if ('Notification' in window && Notification.permission === 'granted') {
      new Notification(title, {
        body: message,
        icon: '/favicon.ico',
      });
    }
  };

  const requestNotificationPermission = async () => {
    if ('Notification' in window && Notification.permission === 'default') {
      await Notification.requestPermission();
    }
  };

  const removeNotification = (id) => {
    setNewNotifications((prev) => prev.filter((notif) => notif._id !== id));
    setOldNotifications((prev) => prev.filter((notif) => notif._id !== id));
  };

  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'Connected':
        return 'green';
      case 'Disconnected':
        return 'red';
      case 'Connection Error':
        return 'orange';
      default:
        return 'gray';
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationContainerRef.current &&
        !notificationContainerRef.current.contains(event.target)
      ) {
        setIsOpenAlarm(false);
      }
      if (profileContainerRef.current && !profileContainerRef.current.contains(event.target)) {
        setIsOpenProfile(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const openViewAllNews = () => {
    setIsDetailNotification(true);
    setIsOpenAlarm(false);
  };

  const openViewProfile = (title) => {
    if (title == 'Cerrar sesión') {
      state.logout();
      navigate('/login');
    } else {
      setIsDetailProfile(title);
      setIsOpenProfile(false);
    }
  };

  const updateNotificationStatus = (notificationId) => {
    console.log('notification status function clicked: ', notificationId);

    const socket = socketRef.current;
    socket.emit('updateNotification', { notificationId: notificationId });

    setIsDetailNotification(false);
    setIsOpenAlarm(false);

    socket.emit('notifications', { userId: snap.user.id });
  };

  return (
    <div className="py-4 px-10 bg-white flex items-center justify-end border-b border-b-[#E6EBF7] rounded-b-[15px] shadow-xs">
      <div className="relative">
        <div className="space-x-[6px] flex items-center justify-center">
          <div className="relative w-6 h-6" ref={notificationContainerRef}>
            <button onClick={() => setIsOpenAlarm(!isOpenAlarm)}>
              <img src={BellIcon} alt="bell icon" className="cursor-pointer w-full h-full" />
            </button>

            {!isDetailNotification && isOpenAlarm && (
              <div className="absolute z-50 right-3 top-[30px] w-80 sm:w-85 py-1 bg-white border-1 border-[#F5F5F5] rounded-tl-2xl rounded-bl-2xl	rounded-br-2xl shadow-lg">
                <div className="flex items-center justify-between p-2 border-b-1 border-b-[#E9EAEB]">
                  <p className="text-xs text-[#252B37] font-medium">Notificaciones</p>
                  <div className="px-2 py-1 space-x-2 flex items-center justify-center bg-[#ECFDF3] rounded-[54px]">
                    <div className="bg-[#12B76A] rounded-full w-[7px] h-[7px]"></div>
                    <p className="text-xs leading-[20px] font-normal text-[#12B76A]">
                      {`${newNotifications.length} nuevas`}
                    </p>
                  </div>
                </div>

                <div className="max-h-50 overflow-y-auto">
                  {newNotifications.map((item, idx) => (
                    <NewItem
                      key={idx}
                      {...item}
                      updateNotificationStatus={updateNotificationStatus}
                    />
                  ))}
                </div>
                <div className="flex item-center justify-center py-2 cursor-pointer">
                  <button onClick={openViewAllNews} className="cursor-pointer">
                    <p className="text-xs text-[#092F7B] font-semibold leading-[20px]">Ver todas</p>
                  </button>
                </div>
              </div>
            )}
          </div>

          <div
            ref={profileContainerRef}
            className="relative bg-[#A3C0FF] w-[35px] h-[35px] rounded-full flex items-center justify-center"
          >
            <button onClick={() => setIsOpenProfile(!isOpenProfile)} className="cursor-pointer">
              {snap.user.avatar ? (
                <img src={snap.user.avatar} alt="avatar" className="w-full h-full rounded-full" />
              ) : (
                <div className="w-full h-full flex items-center justify-center">
                  <p className="font-[poppins] text-white">
                    {snap.user.firstName[0].toUpperCase() + snap.user.lastName[0].toUpperCase()}
                  </p>
                </div>
              )}
            </button>

            {!isDetailProfile && isOpenProfile && (
              <div className="absolute z-50 right-4 top-[40px] w-37 overflow-hidden bg-white border-1 border-[#F5F5F5] rounded-tl-2xl rounded-bl-2xl rounded-br-2xl shadow-lg">
                {profileMenu.map((item, idx) => (
                  <button
                    key={idx}
                    onClick={() => openViewProfile(item.title)}
                    className={`px-4 py-2 space-x-2 cursor-pointer flex items-center ${
                      item.title == 'Cerrar sesión' ? '' : 'border-b-1 border-b-[#F5F5F5] '
                    }`}
                  >
                    {item.icon({
                      size: 'w-4 h-4',
                      color: item.title == 'Cerrar sesión' ? '#F04438' : '#414651',
                    })}
                    <p
                      className={`text-xs font-normal leading-[20px] ${
                        item.title == 'Cerrar sesión' ? 'text-[#F04438]' : 'text-[#414651]'
                      }`}
                    >
                      {item.title}
                    </p>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
        <div className="w-[5px] h-[5px] absolute top-[9.5px] left-[15px] bg-green-500 rounded-full"></div>

        {isDetailNotification && (
          <NotificationModal
            newNotifications={newNotifications}
            oldNotifications={oldNotifications}
            updateNotificationStatus={updateNotificationStatus}
            onClose={() => setIsDetailNotification(false)}
          />
        )}

        {isDetailProfile && (
          <ProfileModal selected={isDetailProfile} onChange={(type) => setIsDetailProfile(type)} />
        )}
      </div>
    </div>
  );
}
